<template>
  <div class="home" id="gp-home">
    
    <div id="gp-wrapper">
      <div class="gp-container">
        <div class="gp-home-container">
    
          <!-- slidewarp -->
          <div class="gp-slides" id="anchor-home">
            <div class="gp-modal2" v-show="flag_modal" id="gp-HomeDetail">
      <a class="modal__close" @click="closeGameDetailModal()">
        <div class="close__sprite"></div>
      </a>
      <div class="content__row content__row--game-modal">
        <div class="game__modal__text">
          <div>
            <div class="game__modal__fob">
              <img :src="this.gameDetailData.detailImg">
            </div>
            <div class="game__modal__text-description">
              <img :src="this.gameDetailData.logoUrl">
              <div class="content__wysiwyg">
                <p v-html="this.gameDetailData.gameIntro"></p>
              </div>
              <div class="game__modal__text-stats">
                <div class="content__row--game-modal mobile">
                  <div class="game__stat">
                    <div class="game__mobile__info">
                      <h5 class="stat__title">{{ $t(`Detail.GAMENAME`) }}</h5>
                      <p>{{ this.gameDetailData.gameName }}</p>
                      <div class="margin-b-1"></div>
                      <h5 class="stat__title">{{ $t(`Detail.DEVELOPER`) }}</h5>
                      <p>{{ this.gameDetailData.gameDeveloper }}</p>
                    </div>
                    <div class="margin-b-1"></div>
                    <div class="game__mobile__info release-dates">

                      <h5 class="stat__title">{{ $t(`Detail.PLATFORM`) }}</h5>
                      <p v-html="this.gameDetailData.gamePlatform"></p>
                      <p v-html="this.gameDetailData.copyright"></p>
                    </div>
                  </div>
                  <div class="game__stat text-align-r">
                    <div class="game__mobile__info game__mobile__info--right mobile">
                      <div class="stat__title margin-t-1">
                        <a target="officialSiteLink" :href="this.gameDetailData.officialSiteLink"
                          class="game__modal__link">
                          <h5>{{ $t(`ButtonText.OFFICIALSITE`) }}</h5>
                        </a>
                      </div>
                      <a v-if="this.gameDetailData.buyLink != '#'"
                        class="game__modal__cta-btn button button-text button--red" :href="this.gameDetailData.buyLink"
                        target="bugGame">
                        <div class="button__background"></div>
                        <div class="button__slide-in"></div>
                        <div class="button__label button__label--default">
                          <span> {{ $t(`ButtonText.BUYNOW`)}} </span>
                        </div>
                        <div class="button__label button__label--hover">
                          <span> {{ $t(`ButtonText.BUYNOW`)}} </span>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>

                <div class="content__row--game-modal desktop">
                  <div class="game__stat">
                    <div>
                      <h5 class="stat__title">{{ $t(`Detail.GAMENAME`) }}</h5>
                      <p>{{ this.gameDetailData.gameName }}</p>
                      <h5 class="stat__title">{{ $t(`Detail.DEVELOPER`) }}</h5>
                      <p>{{ this.gameDetailData.gameDeveloper }}</p>
                    </div>
                  </div>
                  <div class="game__stat">
                    <div class="release-dates">
                      <h5 class="stat__title">{{ $t(`Detail.PLATFORM`) }}</h5>
                      <p v-html="this.gameDetailData.gamePlatform"></p>
                      <p v-html="this.gameDetailData.copyright"></p>
                    </div>
                  </div>
                  <div class="game__stat">
                    <div class="stat__title">
                      <a target="officialSiteLink" :href="this.gameDetailData.officialSiteLink" class="game__modal__link">
                        <h5 class="inline-block">{{ $t(`ButtonText.OFFICIALSITE`) }}</h5>
                      </a>
                    </div>
                    <a v-if="this.gameDetailData.buyLink != '#'" class="game__modal__cta-btn button button-text button--red"
                      :href="this.gameDetailData.buyLink" target="bugGame">
                      <div class="button__background"></div>
                      <div class="button__slide-in"></div>
                      <div class="button__label button__label--default">
                        <span>{{ $t(`ButtonText.BUYNOW`)}}</span>
                      </div>
                      <div class="button__label button__label--hover">
                        <span>{{ $t(`ButtonText.BUYNOW`)}}</span>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="game__modal__image" style="background-image: url()"></div>
      </div>
    </div>
            <!-- slidebar -->
            <div class="gp-slides-arrows desktop">
              <div class="gp-slides-arrow gp-slides-arrow-right" @click="nextSlide()"></div>
              <div class="gp-slides-arrow gp-slides-arrow-left" @click="lastSlide()"></div>
            </div>
            <div class="gp-slides-dots mobile">

              <a v-for="index in slideMaxNum" @click="dotClick(index - 1)" class="gp-slides-dot">
                <div :class="index == 1 ? 'selected' : ''"></div>
              </a>

            </div>
            <!-- slide 
              替换 slide 步骤
              1.更改 logo 与 背景 url  （html与css都有）
              2.slide 文字介绍
              3.视频链接在 video 组件 中根据index更改json数据即可
             -->
            <!-- slide -->
            <div v-for="(item, index) in $t('Home.KVData')" :class="(index == 0) ? 'gp-slide-item' : 'gp-slide-item gp-hide'">
              <div class="gp-slide-item-info">
                <img :src="item.logo" class="gp-slide-item-logo" alt="">
                <div class="gp-slide-item-text">
                  <h1 class="gp-slide-item-h1 text-spaced">{{ item.title }}</h1>
                  <h4 class="gp-slide-item-h4">{{ item.subtitle }}</h4>
                </div>
                <div class="gp-slide-item-buttons">
                  <!-- <a class="button button-text button--transparent" @click="addRouter(item.router)"> -->
                    <a class="button button-text button--transparent" @click="showGameDetailModal(item.router)">
                    <div class="button__background"></div>
                    <div class="button__slide-in"></div>
                    <div class="button__label">
                      <span>{{ $t(`ButtonText.DETAILS`) }}</span>
                    </div>
                  </a>
                  <a class="button button-text button--transparent">
                    <div class="button__background"></div>
                    <div class="button__slide-in"></div>
                    <div class="button__label" @click="showVidio(item.video)">
                      <span>{{ $t(`ButtonText.WATCHTRAILER`) }}</span>
                    </div>
                  </a>
                </div>
                <div class="gp-slide-item-platform">

                  <div class="platform" v-for="platform in item.onlinePlatform">
                    <img :src="platform" style="height: 100%;" />

                  </div>

                </div>

              </div>
              <div class="gp-slide-item-bg">
                <div class="dot-overlay"></div>
                <div class="gp-slide-item-bg-inner">
                  <div :class="'gp-slide-item-bg-image gp-slide-item-bg-image' + index"></div>
                </div>
              </div>
            </div>


          </div>
          <!-- content -->
          <div class="gp-featured-content">
            <!-- partner -->
            <div class="gp-featured-content-row" id="anchor-partner">
              <div class="welcome-slider-area">
                <div id="welcome-slide-carousel" class="carousel slide carousel-fade" data-ride="carousel">
                  <ol class="carousel-indicators carousel-indicators-slider">
                    <li data-target="#welcome-slide-carousel" data-slide-to="0" class="active"></li>
                    <li data-target="#welcome-slide-carousel" data-slide-to="1" class=""></li>
                    <li data-target="#welcome-slide-carousel" data-slide-to="2" class=""></li>
                    <li data-target="#welcome-slide-carousel" data-slide-to="3" class=""></li>
                    <li data-target="#welcome-slide-carousel" data-slide-to="4" class=""></li>
                  </ol>
                  <div class="carousel-inner">
                    <div class="item active">
                      <div class="single-slide-item slide-1">
                        <div class="single-slide-item-table">
                          <div class="single-slide-item-tablecell">
                            <div class="container">
                              <div class="row">
                                <div class="col-md-12" v-if="locale == 'zh'">
                                  <h2 class="single-slide-item-tablecell__title">Gamepoch是索尼互动娱乐在中国非常重要的合作伙伴</h2>
                                  <span></span>
                                  <p>添田武人 索尼互动娱乐（上海）有限公司 总裁</p>
                                  <a class="btn btn-lg btn-custom" @click="addRouter_Anchor('about', 'home')">了解更多</a>
                                </div>
                                <div class="col-md-12" v-else>
                                  <h2 class="single-slide-item-tablecell__title">GAMEPOCH IS A VERY IMPORTANT PARTNER FOR
                                    SIE IN CHINA.</h2>
                                  <span></span>
                                  <p>Takehito Soeda, President of Sony Interactive Entertainment Shanghai</p>
                                  <a class="btn btn-lg btn-custom" @click="addRouter_Anchor('about', 'home')">Learn
                                    More</a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="item">
                      <div class="single-slide-item slide-2">
                        <div class="single-slide-item-table">
                          <div class="single-slide-item-tablecell">
                            <div class="container">
                              <div class="row">
                                <div class="col-md-12" v-if="locale == 'zh'">
                                  <h2 class="single-slide-item-tablecell__title">Gamepoch星 •
                                    奇点体验店项目将对于改变中国主机游戏现状起到积极作用,将成为中国主机及VR历史上浓厚的一笔</h2>
                                  <span></span>
                                  <p>胡斌 掌趣科技 CEO</p>
                                  <a class="btn btn-lg btn-custom" @click="addRouter_Anchor('about', 'home')">了解更多</a>
                                </div>
                                <div class="col-md-12" v-else>
                                  <h2 class="single-slide-item-tablecell__title">
                                    GAMEPOCH EXPERIENCE STORE WILL BE THE SIGNIFICANT AND INNOVATION BUSINESS MODEL IN
                                    CHINA CONSOLE GAME INDUSTRY.
                                  </h2>
                                  <span></span>
                                  <p>Hu bin, CEO of Ourpalm</p>
                                  <a class="btn btn-lg btn-custom" @click="addRouter_Anchor('about', 'home')">Learn
                                    More</a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="item">
                      <div class="single-slide-item slide-3">
                        <div class="single-slide-item-table">
                          <div class="single-slide-item-tablecell">
                            <div class="container">
                              <div class="row">
                                <div class="col-md-12" v-if="locale == 'zh'">
                                  <h2 class="single-slide-item-tablecell__title">
                                    Gamepoch是体育之窗在主机游戏领域重要的合作伙伴，将共同推进体育主机游戏，电竞赛事，中超等授权游戏</h2>
                                  <span></span>
                                  <p>陈亿飙 体育之窗 战略股东</p>
                                  <a class="btn btn-lg btn-custom" @click="addRouter_Anchor('about', 'home')">了解更多</a>
                                </div>
                                <div class="col-md-12" v-else>
                                  <h2 class="single-slide-item-tablecell__title">
                                    GAMEPOCH IS THE KEY PARTNER IN CONSOLE BUSINESS. IRENA WILL WORK WITH GAMEPOCH TO
                                    FOSTER SPORTS CONSOLE TITLES, E-SPORTS AND CSL AUTHORIZED TITLES.
                                  </h2>
                                  <span></span>
                                  <p>Michael Chen, Board Member of iRena</p>
                                  <a class="btn btn-lg btn-custom" @click="addRouter_Anchor('about', 'home')">Learn
                                    More</a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="item">
                      <div class="single-slide-item slide-4">
                        <div class="single-slide-item-table">
                          <div class="single-slide-item-tablecell">
                            <div class="container">
                              <div class="row">
                                <div class="col-md-12" v-if="locale == 'zh'">
                                  <h2 class="single-slide-item-tablecell__title">SNK感受到了Gamepoch在游戏引进上的专业能力以及对游戏产品运营的成熟经验
                                  </h2>
                                  <span></span>
                                  <p>小田泰之 《拳皇14》制作人</p>
                                  <a class="btn btn-lg btn-custom" @click="addRouter_Anchor('about', 'home')">了解更多</a>
                                </div>
                                <div class="col-md-12" v-else>
                                  <h2 class="single-slide-item-tablecell__title">GAMEPOCH HAS COMPREHENSIVE EXPERIENCE IN
                                    PUBLISHING OVERSEAS TITLES AS WELL AS OPERATING TITLES IN CHINA.</h2>
                                  <span></span>
                                  <p>Yasuyuki Oda, Producer of KOF XIV</p>
                                  <a class="btn btn-lg btn-custom" @click="addRouter_Anchor('about', 'home')">Learn
                                    More</a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="item">
                      <div class="single-slide-item slide-5">
                        <div class="single-slide-item-table">
                          <div class="single-slide-item-tablecell">
                            <div class="container">
                              <div class="row">
                                <div class="col-md-12">
                                  <h2 class="single-slide-item-tablecell__title"></h2>
                                  <span></span>
                                  <p></p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- games -->
            <div class="gp-featured-content-row" id="anchor-games">


              <!-- 中文 -->

              <!-- 手机 -->
              <div class="gp-featured-content-row mobile">
                <a href="javascript:void(0);" class="gp-featured-row-item gp-featured-row-tile item--25"
                  v-for="(item, index) in $t('Home.homeGamesMobile')">
                  <div class="featured-row-item-bg" :style="'background-image:url(' + item.bgUrl + ');'"></div>
                  <div class="featured-row-item-text">
                    <!-- <h2 class="featured-row-item-title featured-row-item-game" style="white-space:pre-line;"
                      @click="addRouter(item.id)">{{ item.bgUrl.title }}
                    </h2> -->
                    <!-- <h2 class="featured-row-item-title featured-row-item-game" style="white-space:pre-line;"
                      @click="showGameDetailModal(item.id)">{{ item.bgUrl.title }} -->
                      <h2 class="featured-row-item-title featured-row-item-game" style="white-space:pre-line;"
                     >{{ item.bgUrl.title }}
                    </h2>
                    <p class="featured-row-item-subtitle featured-row-item-subtitle-one-line" v-show="locale === 'zh'">
                      {{ item.subtitle }}
                    </p>

                  </div>
                  <div class="featured-row-item-spacer"></div>
                </a>
              </div>

              <!-- 半屏 -->
              <div class="gp-featured-content-row desktop noFullDesk">
                <!--  -->
                <div id="slide-noFullDesk" class="carousel slide carousel-fade" data-ride="carousel">
                  <div class="carousel-inner">

                    <div class="item" v-for="(item, index) in 5" :class="index === 0 ? 'active' : ''">
                      <a href="javascript:void(0);" class="gp-featured-row-item gp-featured-row-tile item--25"
                        v-for="(item, j) in 4" v-if="(index * 4 + j) <= totalGame">
                        <div class="featured-row-item-bg"
                          :style="'background-image:url(' + $t('Home.homeGames[' + (index * 4 + j) + '].bgUrl') + ');'">
                        </div>
                        <div class="featured-row-item-text">
                          <!-- <h2 class="featured-row-item-title featured-row-item-game" style="white-space:pre-line;"
                            @click="addRouter($t('Home.homeGames[' + (index * 4 + j) + '].id'))">{{
                              $t('Home.homeGames[' + (index * 4 + j) + '].title') }}</h2> -->
                              <!-- <h2 class="featured-row-item-title featured-row-item-game" style="white-space:pre-line;"
                            @click="showGameDetailModal($t('Home.homeGames[' + (index * 4 + j) + '].id'))">{{
                              $t('Home.homeGames[' + (index * 4 + j) + '].title') }}</h2> -->
                              <h2 class="featured-row-item-title featured-row-item-game" style="white-space:pre-line;"
                           >{{
                              $t('Home.homeGames[' + (index * 4 + j) + '].title') }}</h2>
                          <p class="featured-row-item-subtitle featured-row-item-subtitle-one-line"
                            v-show="locale === 'zh'">
                            {{ $t('Home.homeGames[' + (index * 4 + j) + '].subtitle') }}
                          </p>

                        </div>
                        <div class="featured-row-item-spacer"></div>
                      </a>
                    </div>
                  </div>
                  <div class="gp-slides-arrows">
                    <a class="" href="#slide-noFullDesk" data-slide="prev">
                      <div class="gp-slides-arrow gp-slides-arrow-right"></div>
                    </a>
                    <a class="" href="#slide-noFullDesk" data-slide="next">
                      <div class="gp-slides-arrow gp-slides-arrow-left"></div>
                    </a>
                  </div>
                </div>
              </div>

              <!-- 全屏 -->
              <div class="gp-featured-content-row desktop fullDesk">
                <!--  -->
                <div id="slide-fullDesk" class="carousel slide carousel-fade" data-ride="carousel">
                  <div class="carousel-inner">
                    <div class="item" v-for="(item, index) in 4" :class="index === 0 ? 'active' : ''">
                      <a href="javascript:void(0);" class="gp-featured-row-item gp-featured-row-tile item--25"
                        v-for="(item, j) in 6" v-if="(index * 6 + j) <= totalGame">
                        <div class="featured-row-item-bg"
                          :style="'background-image:url(' + $t('Home.homeGames[' + (index * 6 + j) + '].bgUrl') + ');'">
                        </div>
                        <div class="featured-row-item-text">
                          <!-- <h2 class="featured-row-item-title featured-row-item-game" style="white-space:pre-line;"
                            @click="addRouter($t('Home.homeGames[' + (index * 6 + j) + '].id'))">{{
                              $t('Home.homeGames[' + (index * 6 + j) + '].title') }}</h2> -->
                              <!-- <h2 class="featured-row-item-title featured-row-item-game" style="white-space:pre-line;"
                            @click="showGameDetailModal($t('Home.homeGames[' + (index * 6 + j) + '].id'))">{{
                              $t('Home.homeGames[' + (index * 6 + j) + '].title') }}</h2> -->
                               <h2 class="featured-row-item-title featured-row-item-game" style="white-space:pre-line;"
                            >{{
                              $t('Home.homeGames[' + (index * 6 + j) + '].title') }}</h2>
                          <p class="featured-row-item-subtitle featured-row-item-subtitle-one-line"
                            v-show="locale === 'zh'">
                            {{ $t('Home.homeGames[' + (index * 6 + j) + '].subtitle') }}
                          </p>

                        </div>
                        <div class="featured-row-item-spacer"></div>
                      </a>
                    </div>
                  </div>
                  <div class="gp-slides-arrows">
                    <a class="" href="#slide-fullDesk" data-slide="prev">
                      <div class="gp-slides-arrow gp-slides-arrow-right"></div>
                    </a>
                    <a class="" href="#slide-fullDesk" data-slide="next">
                      <div class="gp-slides-arrow gp-slides-arrow-left"></div>
                    </a>
                  </div>
                </div>
              </div>

            </div>
            <!-- news -->
            <h1 class="gp-featured-title">{{ $t('NavBar.News') }}</h1>
            <div class="gp-featured-content-row" id="anchor-news">
              <!-- <a v-for="(item, index) in newsList" :key="index" @click="addRouter(item.id, 'news')" target="_blank"
                class="gp-featured-row-item gp-featured-row-tile item--50">
                <div class="featured-row-item-bg featured-row-item-bg-darker"
                :style="'background-image:url(' + require('../assets/vidio/Video01.jpg') + ');'">
                </div>
                <div class="featured-row-item-text">
                  <h2 class="featured-row-item-title lang-uppercase">{{ VideoTitle(item.post_title) }}</h2>
                  <p class="featured-row-item-subtitle featured-row-item-subtitle-one-line">
                    {{ item.post_excerpt }}
                  </p>
                </div>
                <div class="featured-row-item-spacer-40"></div>
              </a> -->
              <a class="gp-featured-row-item gp-featured-row-tile item--50" @click="showVidio(6)">
              
                <div class="featured-row-item-bg featured-row-item-bg-darker"
                :style="'background-image:url(' + require('../assets/vidio/Video01.jpg') + ');'">
                </div>
                <div class="featured-row-item-text">
                  <h2 class="featured-row-item-title lang-uppercase">{{ VideoTitle(1) }}</h2>
                  <p class="featured-row-item-subtitle featured-row-item-subtitle-one-line">
                    {{ VideoDescrition(1) }}
                  </p>
                </div>
                <div class="featured-row-item-spacer-40"></div>
              </a>
              <a class="gp-featured-row-item gp-featured-row-tile item--50" @click="showVidio(7)">
              
              <div class="featured-row-item-bg featured-row-item-bg-darker"
              :style="'background-image:url(' + require('../assets/vidio/Video02.jpg') + ');'">
              </div>
              <div class="featured-row-item-text">
                <h2 class="featured-row-item-title lang-uppercase">{{ VideoTitle(2) }}</h2>
                <p class="featured-row-item-subtitle featured-row-item-subtitle-one-line">
                  {{ VideoDescrition(2) }}
                </p>
              </div>
              <div class="featured-row-item-spacer-40"></div>
            </a>
            <a class="gp-featured-row-item gp-featured-row-tile item--50" @click="showVidio(8)">
              
              <div class="featured-row-item-bg featured-row-item-bg-darker"
              :style="'background-image:url(' + require('../assets/vidio/Video03.jpg') + ');'">
              </div>
              <div class="featured-row-item-text">
                <h2 class="featured-row-item-title lang-uppercase">{{ VideoTitle(3) }}</h2>
                <p class="featured-row-item-subtitle featured-row-item-subtitle-one-line">
                  {{ VideoDescrition(3) }}
                </p>
              </div>
              <div class="featured-row-item-spacer-40"></div>
            </a>
            </div>
            <!-- weibo -->
            <!-- <h1 class="gp-featured-title">{{ $t('NavBar.Weibo') }}</h1>
            <div class="gp-featured-content-row gp-featured-content-row-social" id="anchor-weibo">
              <div class="gp-featured-content-stackla" :lang="locale">
                <a target="_blank" v-for="(item, index) in $t('Home.weiboNewsData')" :key="index" :href="item.url"
                  class="gp-featured-row-item gp-featured-row-tile item--33 tile--stackla">
                  <div class="featured-row-item-image-stackla">
                    <div class="play-btn"></div>
                    <div class="featured-row-item-bg featured-row-item-bg-darker" :style="item.img"></div>
                    <div class="featured-row-item-text featured-row-item-text-stackla-platform">
                      <div class="stackla__info" v-show="false">
                        <div class="stackla__platform-icon stackla__platform-icon--twitter"></div>
                        <div class="stackla__tile-user">&nbsp;|&nbsp;</div>
                        <div class="stackla__tile-date"></div>
                      </div>
                    </div>
                  </div>
                  <div class="featured-row-item-text featured-row-item-text-stackla">
                    <div class="stackla__text">
                      <p>
                        {{ item.title }}
                      </p>
                    </div>
                  </div>
                  <div class="featured-row-item-spacer-40"></div>
                </a>
                <a v-show="false" href="" class="gp-featured-row-item gp-featured-row-tile item--33 tile--stackla">
                  <div class="featured-row-item-image-stackla">
                    <div class="play-btn"></div>
                    <div class="featured-row-item-bg featured-row-item-bg-darker"
                      :style="'background-image:url(' + require('../assets/home/video2.jpg') + ');'"></div>
                    <div class="featured-row-item-text featured-row-item-text-stackla-platform">
                      <div class="stackla__info" v-show="false">
                        <div class="stackla__platform-icon stackla__platform-icon--twitter"></div>
                        <div class="stackla__tile-user">PGATOUR2K&nbsp;|&nbsp;</div>
                        <div class="stackla__tile-date">11 May</div>
                      </div>
                    </div>
                  </div>
                  <div class="featured-row-item-text featured-row-item-text-stackla">
                    <div class="stackla__text">
                      <p>
                        拳皇15 概念设计 两位角色的3D模型都比起前作帅气了很多！ 请期待新生龙虎队的表现吧！
                      </p>
                    </div>
                  </div>
                  <div class="featured-row-item-spacer-40"></div>
                </a>
                <a v-show="false" href="" class="gp-featured-row-item gp-featured-row-tile item--33 tile--stackla">
                  <div class="featured-row-item-image-stackla">
                    <div class="play-btn"></div>
                    <div class="featured-row-item-bg featured-row-item-bg-darker"
                      :style="'background-image:url(' + require('../assets/home/video3.jpg') + ');'"></div>
                    <div class="featured-row-item-text featured-row-item-text-stackla-platform">
                      <div class="stackla__info" v-show="false">
                        <div class="stackla__platform-icon stackla__platform-icon--twitter"></div>
                        <div class="stackla__tile-user">NBA 2K&nbsp;|&nbsp;</div>
                        <div class="stackla__tile-date">8 May</div>
                      </div>
                    </div>
                  </div>
                  <div class="featured-row-item-text featured-row-item-text-stackla">
                    <div class="stackla__text">
                      <p>
                        拳皇15 龙虎队 新作格斗对战游戏《拳皇15》“坂崎良”、 “罗伯特·加西亚”角色介绍短片发布！ “良”、“罗伯特”、“ 琼
                      </p>
                    </div>
                  </div>
                  <div class="featured-row-item-spacer-40"></div>
                </a>
                <a v-show="false" href="" class="gp-featured-row-item gp-featured-row-tile item--33 tile--stackla">
                  <div class="featured-row-item-image-stackla">
                    <div class="play-btn"></div>
                    <div class="featured-row-item-bg featured-row-item-bg-darker"
                      :style="'background-image:url(' + require('../assets/home/video4.jpg') + ');'"></div>
                    <div class="featured-row-item-text featured-row-item-text-stackla-platform">
                      <div class="stackla__info" v-show="false">
                        <div class="stackla__platform-icon stackla__platform-icon--twitter"></div>
                        <div class="stackla__tile-user">Borderlands&nbsp;|&nbsp;</div>
                        <div class="stackla__tile-date">30 Apr</div>
                      </div>
                    </div>
                  </div>
                  <div class="featured-row-item-text featured-row-item-text-stackla">
                    <div class="stackla__text">
                      <p>
                        拳皇15 大蛇队 大家期待的——夏尔美 来了！ 那么问题来了，她的队友都会是谁呢 [并不简单] SNK官方的微博视频 ​​​​
                      </p>
                    </div>
                  </div>
                  <div class="featured-row-item-spacer-40"></div>
                </a>
              </div>
            </div> -->
            <!-- about us -->
            <!-- <div class="gp-featured-content-row" id="anchor-about">
              <div class="row text-center container " v-if="locale == 'zh'">
                <div class="section-title text-center anchor-about">
                  <h2>关于我们</h2>
                  <span></span>
                  <p style="text-align:left;">
                    GAMEPOCH 致力于游戏发行和电子竞技赛事运营，自2015年相继为中国用户带来了数十款国行优质内容， 由我们主办的各种主机电竞赛事也给玩家们带来了回味无穷的视觉盛宴。
                    <br>
                    <br>
                    作为业内资深的主机游戏发行商，我们在 2019 年受邀出任中国 5G 云游戏产业联盟理事单位，并成为《云游戏产业发展白皮书》、《云游戏：5G开启数字娱乐新时代》的主要撰稿人。目前，由 GAMEPOCH
                    带来的数十款 5G 云游戏已大大丰富市场的内容和种类，特别是 3A 品质主机游戏结合 5G 云游戏 技术带来的低延时，高速的特点，也给用户带来游戏体验上的巨大升级。
                    <br>
                    <br>
                    我们在发行游戏的同时，也与电信，联通，移动，腾讯等诸多头部企业达成了合作共识， 一起为玩家带来真正的云游戏。从耳熟能详的格斗电竞游戏《拳皇15》《侍魂 晓》，到风靡全球的主机年度体育大作《NBA
                    2K》系列，还有WRC世界汽车拉力锦标赛官方授权的硬核拟真赛车游戏《WRC》系列，将来也会带来更多的超休闲游戏内容，把游戏的快乐特快传递给玩家们。
                  </p>
                </div>
              </div>
              <div class="row text-center container " v-else>
                <div class="section-title text-center anchor-about">
                  <h2>ABOUT US</h2>
                  <span></span>
                  <p style="text-align:left;line-height: 25px;text-align:justify;margin-top: 100px;">
                    <i style="font-size:22px;text-align:center;display: inline-block;width: 100%;color: #fff;">“We are
                      United because of U”</i>
                    <br>
                    <br>
                    <i style="font-size:18px;color: #d8d0d0;">Vision</i>
                    <br>
                    <br>
                    We set our feet in so many fields – Console game, mobile game, cloud game, etc. in that we are
                    determined to replicate joy from one to another through games— “U” are the reason we are untied and
                    where our original heart lies.
                    <br>
                    <br>
                    <i style="font-size:18px;color: #d8d0d0;">Value</i>
                    <br>
                    <br>
                    Our employees brand our value, our value is our brand. “Experienced” and “Trustworthy” forges the
                    brand under which we’ve relied and deemed as the root we got fed. Hence, GAMEPOCH is a synonym equals
                    “Professional Game Publisher”.
                    <br>
                    <br>
                    <i style="font-size:18px;color: #d8d0d0;">Vicissitudes</i>
                    <br>
                    <br>
                    As a veteran strived in the game industry for nearly a decade, GAMEPOCH boasts itself an seasoned role
                    in game publishing and eSports operating. SAMURAI SHODOW, KING OF FIGHTERS XIV, WRC series and NBA
                    2K19/20, the mentioned names engrave our history and their success shine our past glories. Our
                    concrete relationship with game giants like SNK, Take-Two, Sony etc., made so many milestone games
                    available in China.
                    <br>
                    <br>
                  </p>
                </div>
              </div>
            </div> -->
          </div>
          <!-- content -->
        </div>
      </div>
    </div>
   
    <div class="gp-modal" v-show="flag_Vidio">
      <a class="modal__close" @click="video_Close('close')">
        <div class="close__sprite"></div>
      </a>
      <gpVidio class="gp-vidio" :vidio_Index="vidio_Index" />
    </div>
    
  </div>
</template>

<script>
import gpVidio from "../components/gp-vidio.vue";
import '../common/style/slider.css'
import '../common/style/index.css'
export default {
  name: 'home',
  data() {
    return {
      current_SlideIndex: 0,
      timer_SlideAutoPlay: "",
      slideMaxNum: 6,
      flag_Vidio: false,
      vidio_Index: 0,
      newsList: [],
      tempZH: [],
      tempEN: [],
      dashboard: [],
      flag_modal: false,
      flag_modal_video: false,
      current_game_vidio: "",
      gameDetailData: {},
      language: 'chinese'
    }
  },
  created() {
    this.getData();
    //this.initData();
  },
  computed: {
    totalGame: function () {
      return this.$i18n.t('Home.homeGames').length - 1
    },
    locale: function () {
      return this.$i18n.locale
    }
  },
  watch: {
    locale: {
      handler(newVal, oldVal) {
       // this.initData()
      }

    }
  },
  components: {
    gpVidio
  },
  mounted() {
    this.initRender();
    document.body.classList.remove('body-hidden');
    this.slideMaxNum = this.$i18n.t('Home.KVData').length
  },
  beforeDestroy() {
    clearInterval(this.timer_SlideAutoPlay);
    clearTimeout(this.debounceTimer);
  },
  methods: {
    newsTitle: function (_originTitle) {
      if (this.locale == 'zh') return _originTitle;
      let newTtile1, newTtile2, newTtile3;
      newTtile1 = _originTitle.split("!")[0];
      newTtile2 = _originTitle.split(".")[0];
      newTtile3 = _originTitle.split(",")[0];
      if (newTtile1.replace(/[\u0391-\uFFE5]/g, "aa").length <= 80) {
        return newTtile1
      } else if (newTtile2.replace(/[\u0391-\uFFE5]/g, "aa").length <= 80) {
        return newTtile2
      } else {
        return newTtile3
      }

    },
    VideoTitle:function(_TitleID)
    {
      if (this.locale == 'zh') 
      {
        switch(_TitleID)
        {
          case 1:
          return '打造沉浸式互动体验新纪元';
          case 2:
          return '拳星出击，皇者归来！';
          case 3:
          return '冠军之夜，燃爆激情！';
        }
      }
      else
      {
        switch(_TitleID)
        {
          case 1:
          return 'The new era of immersive interactive experience';
          case 2:
          return 'The boxing star strikes, the emperor returns!';
          case 3:
          return 'The night of the champion, igniting passion!';
        }
      }

    

    },
    VideoDescrition:function(_TitleID)
    {
      if (this.locale == 'zh') 
      {
        switch(_TitleID)
        {
          case 1:
          return 'GAMEPOCH 环球港线下体验馆';
          case 2:
          return '《拳皇14》中国电竞赛总决赛';
          case 3:
          return 'NBA 2K18 亚洲锦标赛中国区总决赛';
        }
      }
      else
      {
        switch(_TitleID)
        {
          case 1:
          return 'GAMEPOCH Global Harbor Offline Experience Center';
          case 2:
          return 'The Grand Finals of the Chinese E-sports Tournament for The King of Fighters 14';
          case 3:
          return 'NBA 2K18 Asia Championship China Finals';
        }
      }
    

    },
    initData() {
      var v_this = this;
      let temp = []
      let ajaxUrl;
      if (v_this.locale == 'en') {
        ajaxUrl = 'https://newseditor.gamepoch.com/thinkcmf/data_news.php?post_net=gamepoch.com';
        if (this.tempEN.length == 3) {
          this.newsList = this.tempEN;
          return
        }

      }
      if (v_this.locale == 'zh') {
        ajaxUrl = 'https://newseditor.gamepoch.com/thinkcmf/data_news.php?post_net=gamepoch.cn';
        if (this.tempZH.length == 3) {
          this.newsList = this.tempZH;
          return;
        }
      }
      $.get(ajaxUrl)
        .then(data => {
          data.map(function (item, index) {
            if (index == 1 || index == 2 || index == 0) {
              temp.push(item);
            }
            if (index == 4) {
              throw 'jieshu'
            }
            v_this.$nextTick(function () {
              //给新闻第三个item添加class 
              $("#anchor-news a:eq(2)").addClass("lfd")
            });
          })
        })
        .catch(function (error) {
          console.log(error);
        });
      if (v_this.locale == 'zh') {
        this.tempZH = temp;
        this.newsList = temp;
      } else {
        this.tempEN = temp;
        this.newsList = temp;
      }

    },
    getData() {
    
        const ajaxUrl = 'http://www.miniadmin.test/api/get/kv';
        $.get(ajaxUrl)
          .then(data => {
          })
          .catch(function (error) {
            console.log(error);
          });
    },
    initRender() {
      //显示首屏图片
      this.showFirstSlide();
      //开启自动轮播
      this.timer_SlideAutoPlay = setInterval(() => {
        this.autoPlaySlide();
      }, 10000);

    },
    showFirstSlide() {
      clearInterval(this.timer_SlideAutoPlay);
      this.current_SlideIndex = 0;
      let _current_slide_item = document.getElementsByClassName("gp-slide-item-info")[this.current_SlideIndex];
      _current_slide_item.classList.add('animate__animated');
      _current_slide_item.classList.add('animate__fadeIn');
    },
    //自动轮播
    autoPlaySlide() {
      let _oldIndex = this.current_SlideIndex;
      if (this.current_SlideIndex == this.slideMaxNum - 1) {
        this.current_SlideIndex = 0;
      } else {
        this.current_SlideIndex++;
      }
      this.changeSlide(_oldIndex);
    },
    //轮播 下一页
    nextSlide() {
      clearInterval(this.timer_SlideAutoPlay);
      this.autoPlaySlide();
      this.timer_SlideAutoPlay = setInterval(() => {
        this.autoPlaySlide();
      }, 10000);
    },
    //轮播 上一页
    lastSlide() {
      clearInterval(this.timer_SlideAutoPlay);
      let _oldIndex = this.current_SlideIndex;
      if (this.current_SlideIndex == 0) {
        this.current_SlideIndex = this.slideMaxNum - 1;
      } else {
        this.current_SlideIndex--;
      }
      this.changeSlide(_oldIndex);

      this.timer_SlideAutoPlay = setInterval(() => {
        this.autoPlaySlide();
      }, 10000);
    },
    // 轮播 下 dot 击切换 图片
    dotClick(_index) {
      clearInterval(this.timer_SlideAutoPlay);

      let _oldIndex = this.current_SlideIndex;
      this.current_SlideIndex = _index;
      this.changeSlide(_oldIndex);

      this.timer_SlideAutoPlay = setInterval(() => {
        this.autoPlaySlide();
      }, 10000);
    },
    changeSlide(_oldIndex) {
      // 获取要改变 Class 的元素对象
      let _current_slide_item = document.getElementsByClassName("gp-slide-item")[_oldIndex];
      let _next_slide_item = document.getElementsByClassName("gp-slide-item")[this.current_SlideIndex];

      let _current_slide_item_info = document.getElementsByClassName("gp-slide-item-info")[_oldIndex];
      let _next_slide_item_info = document.getElementsByClassName("gp-slide-item-info")[this.current_SlideIndex];

      let _current_slide_dot = document.getElementsByClassName("gp-slides-dot")[_oldIndex].getElementsByTagName("div")[0];
      let _next_slide_dot = document.getElementsByClassName("gp-slides-dot")[this.current_SlideIndex].getElementsByTagName("div")[0];

      // 隐藏当前轮播页
      _current_slide_item.classList.add('gp-hide');
      _current_slide_item_info.classList.remove('animate__animated');
      _current_slide_item_info.classList.remove('animate__fadeIn');
      _current_slide_dot.classList.remove('selected');

      // 切换下一个轮播页
      _next_slide_item.classList.remove('gp-hide');
      _next_slide_item_info.classList.add('animate__animated');
      _next_slide_item_info.classList.add('animate__fadeIn');
      _next_slide_dot.classList.add('selected');
    },
    showVidio(_index) {
      this.vidio_Index = _index;
      if (this.flag_Vidio) {
        this.flag_Vidio = false;
      } else {
        this.flag_Vidio = true;
      }
      document.body.classList.add('body-hidden');
      document.getElementById("gp-home").style.zIndex = 101;
    },
    video_Close(type) {
      if (type == "close") {
        this.flag_Vidio = false;
      }
      document.getElementById("gp-vidio").pause();
      document.body.classList.remove('body-hidden');
      document.getElementById("gp-home").style.zIndex = 99;
    },
    addRouter(_index, roter) {

      let _route;
      if (roter) {
        _route = roter;
        this.$router.push(
          {
            path: `/` + _route,
            name: _route,
            query: {
              index: _index
            }
          })
      } else {
        // if (_index == 0) {
        //   window.open('https://kof.gamepoch.com/');
        //   return;
        // }
        _route = "detail";
        this.$router.push(
          {
            path: `/` + _route,
            name: _route,
            query: {
              id: _index
            }
          })
      }

    },
    addRouter_Anchor(_anchor, _route) {
      var anchor = document.querySelector("#anchor-" + _anchor)
      if (anchor) {
        anchor.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
      }
    },
    showGameDetailModal(GameID) {
    //   if (this.$i18n.locale=='zh') this.gameDetailData = gameDetails[this.$route.query.id - 1]
    // else this.gameDetailData = gameDetails_En[this.$route.query.id - 1]
    this.gameDetailData=this.$i18n.t(`Detail.gameDetail`)[GameID]
      this.flag_modal = true;
      document.body.classList.add('body-hidden');
      document.getElementById("gp-HomeDetail").style.zIndex = 110;
    },
    closeGameDetailModal() {
      this.flag_modal = false;
      document.body.classList.remove('body-hidden');
      document.getElementById("gp-HomeDetail").style.zIndex = 99;
    },
    openUrl(_url) {

      window.open(_url);
    }
  }
}
// <img src="./assets/logo.png">
//     <router-view/>

</script>

<style scoped lang="scss">
@keyframes fade-in {
  0% {
    opacity: 0
  }

  to {
    opacity: 1
  }
}

@keyframes home-game-preview {
  0% {
    transform: scale(1)
  }

  to {
    transform: scale(1.1)
  }
}

.p-ISBN {
  font-size: 12px
}

#gp-wrapper {
  animation-name: fade-in;
  animation-duration: 1s;
}

#gp-home {
  position: relative;
}

.gp-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8)
}
.gp-modal2 {
  min-height: 100vh;
  width: 100%;
  height: 100%;
  position: relative;
  background:rgba(0, 0, 0, 1);
}
.content__row--game-modal2 iframe {
  width: 100vw;
  height: 100vh;
}
.content__row--game-modal {
  display: table;
  width: 100%;
  height: 100%
}

.game__modal__text {
  width: 100%;
  display: table-cell;
  vertical-align: middle;
  height: 100%;
  padding: 68px 20px
}

.game__modal__text>div {
  width: 80%;
  max-width: 1400px;
  margin: 0 auto;
  overflow: hidden
}

@media (min-width: 0em) and (max-width:800px) {
  .game__modal__text {
    padding: 0;
    width: 100vw
  }

  .game__modal__text>div {
    width: 90%;
    margin: 56px auto 0
  }
}
.game__stat {
  display: table-cell;
  vertical-align: top;
  color: #7a7979;
  min-width: 100px;
}
.stat__title {
  color: #cacaca;
  margin-top: 1em
}

@media (min-width: 0em) and (max-width:800px) {
  .stat__title {
    margin-top: 0
  }
}

.release-dates {
  font-size: 1em
}

.release-dates p {
  margin-top: 1em
}

.release-dates p:nth-child(2) {
  margin-top: 0px !important;
}

.release-dates li {
  color: #cacaca;
  padding-bottom: 6px
}

@media (min-width: 0em) and (max-width:800px) {
  .release-dates {
    font-size: .8em
  }

  .release-dates li {
    padding-bottom: 0
  }
}
.game__modal__link {
  display: block
}

@media (min-width: 0em) and (max-width:800px) {
  .game__modal__link {
    font-size: 1.45em
  }
}

.game__modal__cta-btn {
  margin-top: 1em
}

.game__mobile__info--right {
  text-align: right;
  margin-bottom: 35px
}



.game__body {
  width: 100%
}
.game__modal__text {
  width: 100%;
  display: table-cell;
  vertical-align: middle;
  height: 100%;
  padding: 270px 20px
}
.game__modal__fob {
  vertical-align: top;
  width: 40%;
  max-width: 400px;
  float: left
}

@media (min-width: 0em) and (max-width:800px) {
  .game__modal__fob {
    display: block;
    width: auto;
    margin: 0 auto;
    float: none
  }
}

.game__modal__fob>img {
  padding-right: 15%;
  width: 100%
}

@media (min-width: 0em) and (max-width:800px) {
  .game__modal__fob>img {
    padding-top: 0;
    padding-right: 0;
    padding-bottom: 10%
  }
}
.game__modal__text-description {
  overflow: hidden;
  margin-bottom: 10%
}

@media (min-width: 0em) and (max-width:800px) {
  .game__modal__text-description {
    width: 100%
  }
}

.game__modal__text-description>img {
  margin-bottom: 12px;
  max-width: 300px
}

.game__modal__text-description>p {
  color: #cacaca
}

.game__modal__text-description .disclaimer {
  color: #515151
}

@media (min-width: 0em) and (max-width:800px) {
  .game__modal__text-description>img {
    width: 70%
  }

  .game__modal__text-description>h1 {
    font-size: 2.7em
  }

  .game__modal__text-description>p {
    line-height: 1.1
  }
}

@media (min-width: 0em) and (max-width:800px) {
  .game__modal__text-stats {
    margin-top: 45px
  }
}
.gp-vidio {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-flow: column;
  justify-content: center;
  opacity: 1;
}

#gp-wrapper,
.gp-container,
.gp-home-container {
  min-height: 100vh;

}

.gp-home-container {
  width: 100%;
  height: 100%;
  position: relative;
}

.gp-slides {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;

  .gp-slides-arrows {

    position: absolute;
    z-index: 9;
    top: 50%;
    right: 50px;
    margin-top: -55px;

    .gp-slides-arrow {
      cursor: pointer;
      transition: transform .3s;
    }

    .gp-slides-arrow:hover {
      transform: scale(1.1)
    }

    .gp-slides-arrow-right,
    .gp-slides-arrow-left {
      background-image: url(../assets/sprite-ui.png);
      background-size: 302.5px 276.5px;
      width: 27.5px;
      height: 52px;
    }

    .gp-slides-arrow-right {
      background-position: -132px 0;
    }

    .gp-slides-arrow-left {
      background-position: 0 -100px;
    }
  }

  .gp-slides-dots {
    position: absolute;
    z-index: 3;
    bottom: 6px;
    right: 12px;

    .gp-slides-dot {
      display: inline-block;
      padding: 6px;
    }

    .gp-slides-dot>* {
      width: 10px;
      height: 10px;
      border-radius: 500px;
      background-color: #e1e1e1;
      cursor: pointer;
    }

    .gp-slides-dot>.selected {
      background-color: red;
    }
  }

  .gp-slide-item .gp-slide-item-bg-image,
  .gp-slide-item .gp-slide-item-bg-inner {
    position: relative;
    z-index: 1;
    width: 100%;
    height: 100%;
  }

  // 首页轮播动画
  .gp-anime-hide-add {
    transition: opacity 1.5s linear;
    display: block;
    opacity: 1;
  }

  .gp-anime-hide-remove {
    transition: opacity 3.5s linear;
    display: block;
  }

  .gp-anime-hide-remove .gp-slide-item-bg {
    transition: opacity 1.5s linear;
    opacity: 0;
  }

  .gp-anime-hide-remove .gp-slide-item-info {
    transition: opacity 1.5s linear;
    transition-delay: 2s;
    opacity: 0;
  }

  .gp-anime-hide-remove.gp-anime-hide-remove-active .gp-slide-item-bg,
  .gp-anime-hide-remove.gp-anime-hide-remove-active .gp-slide-item-info {
    opacity: 1
  }

  .gp-slide-item-info {
    animation-delay: 1.5s;
    animation-duration: 1.5s;
  }

  .gp-slide-item {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    .gp-slide-item-info {
      position: absolute;
      left: 92px;
      top: 42%;
      width: 50%;
      transform: translateY(-40%);
      color: #fff;
      z-index: 6;

      .gp-slide-item-logo {
        width: 60%;
        max-width: 490px;
        margin-bottom: 3px;
      }

      .gp-slide-item-h1 {
        // font-family: Roboto Condensed,sans-serif;
        font-weight: 700;
        font-style: italic;
        font-size: 2.5em;
      }

      .gp-slide-item-h4 {
        // font-family: Roboto,sans-serif;
        font-weight: 400;
      }

      .gp-slide-item-buttons {
        margin-top: 20px;
        margin-bottom: -8px;
      }

      .gp-slide-item-platform {
        margin-top: 20px;
        margin-bottom: -8px;
      }

      .platform {
        overflow: hidden;
        display: inline-block;
        vertical-align: middle;
        position: relative;
        border-radius: 0;
        outline: none;
        margin: 0 8px 8px 0;
        text-align: center;
        width: 70px;
        img{
          font-weight: 700;
          font-size: 15px;
          padding: .5em;
          
        }
      }
    }

    .gp-slide-item-bg {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 2;
      display: block;
      overflow: hidden;

      .dot-overlay {
        position: absolute;
        z-index: 2;
        background-image: url(../assets/pattern.png);
        background-repeat: repeat !important;
        background-attachment: scroll;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        opacity: .5;
      }

      .gp-slide-item-bg-inner {
        position: relative;
        z-index: 1;
        width: 100%;
        height: 100%;

        .gp-slide-item-bg-image {
          overflow: hidden;
          background-position: 50%;
          background-repeat: no-repeat;
          background-size: cover;
          animation-name: home-game-preview;
          animation-duration: 10s;
          animation-fill-mode: forwards;
          animation-timing-function: linear;

        }
      }
    }
  }
}

@media (min-width: 0em) and (max-width: 800px) {
  .gp-slides {
    .gp-slide-item {
    .gp-slide-item-info {
      .gp-slide-item-platform {
        margin-top: 20px;
        margin-bottom: -8px;
      }

      .platform {
        width: 33%;
        min-width: 0 !important;
        img{
          font-weight: 700;
          padding: .5em 1em !important;
          
        }
      }
    }

    
  }
  }
}
.gp-slide-item-bg-image0 {
  background-image: url(../assets/home/FenyxRising_KV.jpg);
}
.gp-slide-item-bg-image1 {
  background-image: url(../assets/home/Horizon-Zero-Dawn_KV.jpg);
}
.gp-slide-item-bg-image2 {
  background-image: url(../assets/home/TowerOfFantasy_KV.jpg);
}
.gp-slide-item-bg-image3 {
  background-image: url(../assets/home/KOF15_KV.jpg);
}

.gp-slide-item-bg-image4 {
  background-image: url(../assets/home/ud_KV.jpg);
}

.gp-slide-item-bg-image5 {
  background-image: url(../assets/home/RhythmPlanet_KV.jpg);
}

.gp-slide-item-bg-image6 {
  background-image: url(../assets/home/Samurai_KV.jpg);
}

.gp-slide-item-bg-image7 {
  background-image: url(../assets/home/KOF_KV.jpg);
}

.gp-slide-item-bg-image8 {
  background-image: url(../assets/home/WRC8_KV.jpg);
}

.gp-slide-item-bg-image9 {
  background-image: url(../assets/home/XT_KV.jpg);
}

@media (min-width: 0em) and (max-width: 800px) {
  .gp-slibgde-item--image0 {
    background-image: url(../assets/home/FenyxRising_KV_Phone.jpg) !important;
  }
  .gp-slide-item-bg-image1 {
    background-image: url(../assets/home/Horizon-Zero-Dawn_KV_Phone.jpg) !important;
  }
  .gp-slide-item-bg-image2 {
    background-image: url(../assets/home/TowerOfFantasy_KV_Phone.jpg) !important;
  }
  .gp-slide-item-bg-image3 {
    background-image: url(../assets/home/KOF15_KV_Phone.jpg) !important;
  }

  .gp-slide-item-bg-image4 {
    background-image: url(../assets/home/ud_KV_Phone.jpg) !important;
  }

  .gp-slide-item-bg-image5 {
    background-image: url(../assets/home/RhythmPlanet_KV.jpg) !important;
  }

  .gp-slide-item-bg-image6 {
    background-image: url(../assets/home/Samurai_KV_Phone.jpg) !important;
  }

  .gp-slide-item-bg-image7 {
    background-image: url(../assets/home/KOF_KV_Phone.jpg) !important;
  }

  .gp-slide-item-bg-image8 {
    background-image: url(../assets/home/WRC8_KV_Phone.jpg) !important;
  }

  .gp-slide-item-bg-image9 {
    background-image: url(../assets/home/XT_KV.jpg) !important;
  }
}

.inactive .gp-slide-item-bg-image {
  animation: none !important;
}

@media (min-width: 0em) and (max-width: 800px) {
  .gp-slide-item .gp-slide-item-info {
    width: 90% !important;
    left: 20px !important;
    bottom: 2em !important;
    top: auto !important;
    transform: none !important;
  }

}

.gp-featured-content {
  width: 100%;
  position: relative;
}

.gp-featured-title {
  font-size: 1.7em;
  display: none;
  margin: 32px 0 32px 18px;
}

@media (min-width: 0em) and (max-width: 800px) {
  .gp-featured-title {
    display: block !important;
  }
}

// content
.gp-featured-content-row {
  width: 100%;

  .gp-featured-row-item {
    position: relative;
    float: left;
  }

  .gp-featured-row-tile {
    overflow: hidden;
    cursor: pointer;
    background-color: #000;
    display: block;
  }

  .item--25 {
    width: 25%;
  }

  .item--33 {
    width: 33.33%
  }

  .item--50 {
    width: 50%;
  }

  .p-ISBN:hover,
  .featured-row-item-title:hover {
    color: #bbb;
  }

  .gp-featured-row-tile:hover {
    // background-color: #cc0001;

  }

  .gp-featured-row-tile:hover .featured-row-item-bg {
    transform: scale(1.1);
    // filter: grayscale(50%);
  }

  .gp-featured-row-tile:hover .featured-row-item-bg {
    // opacity: .2;
  }

  @media (min-width: 0em) and (max-width: 800px) {
    .gp-featured-row-item {
      width: 100% !important;
      // float: none;
      display: block;
    }
  }

  @media (min-width: 1920px) {
    .gp-featured-content-row .item--25 {
      display: block;
      width: 16.66666% !important;
    }
  }

  .featured-row-item-bg {
    background-size: cover;
    background-position: 50%;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transition: all .3s;
  }

  .featured-row-item-bg-darker {
    opacity: .6;
  }

  .featured-row-item-text {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 22px;
    // padding-bottom: 7px;
    color: #fff;

    * {
      position: relative;
      z-index: 2;
    }

    .featured-row-item-title {
      width: 100% !important;
      display: block !important;
      font-family: Roboto Condensed, sans-serif;
      font-weight: 700;
      margin: 0;
      line-height: 1.1;
    }

    .featured-row-item-game {
      width: 90%;
      display: table-cell;
      text-transform: uppercase;
    }
  }

  .featured-row-item-text:after {
    transition: opacity .3s;
    display: block;
    content: "";
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    width: 101%;
    height: 100%;
    background-image: linear-gradient(180deg, transparent, rgba(0, 0, 0, .5) 50%);
  }

  .featured-row-item-spacer {
    padding-bottom: 100% !important;
  }

  .featured-row-item-spacer-40 {
    padding-bottom: 40% !important;
  }

  .featured-row-item-subtitle {
    transition: color .3s;
    margin: 0;
    // color: #cacaca;

  }

  .featured-row-item-subtitle-one-line {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
}

.gp-featured-content-row-social {
  text-overflow: ellipsis;
}

.gp-featured-content-row:after {
  display: table;
  content: " ";
  clear: both;
  height: 0;
}

.gp-featured-content-row .item--25.lfd {
  display: block
}

.gp-featured-content-row .item--50.lfd {
  display: block;
}

@media (min-width: 768px) and (max-width:1024px) and (orientation:portrait) {
  .gp-featured-content-row .item--50.lfd {
    display: none
  }
}

@media (min-width: 1024px) and (max-width:1918px) and (orientation: landscape) {
  .gp-featured-content-row .item--50.lfd {
    display: none;
  }
}

@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .gp-featured-content-row .item--50.lfd {
    display: none;
  }
}

@media (min-width: 1920px) {
  .gp-featured-content-row .item--50 {
    display: block;
    width: 33.33333%;
  }
}

@media (min-width: 768px) and (max-width:1024px) and (orientation:portrait) {
  .gp-featured-content-row .item--25.lfd {
    display: none
  }
}

@media (min-width: 1024px) and (max-width:1918px) and (orientation:landscape) {
  .gp-featured-content-row .item--25.lfd {
    display: none
  }
}

@media (min-width: 768px) and (max-width:1024px) and (orientation:landscape) {
  .gp-featured-content-row .item--25.lfd {
    display: none;

  }
}

@media (min-width: 1920px) {
  .gp-featured-content-row .item--25 {
    display: block;
    width: 16.66666%
  }
}

.gp-featured-content-row .item--33.lfd {
  display: block
}

@media (min-width: 768px) and (max-width:1024px) and (orientation:portrait) {
  .gp-featured-content-row .item--33.lfd {
    display: none
  }
}

@media (min-width: 1024px) and (max-width:1918px) and (orientation:landscape) {
  .gp-featured-content-row .item--33.lfd {
    display: none
  }
}

@media (min-width: 768px) and (max-width:1024px) and (orientation:landscape) {
  .gp-featured-content-row .item--33.lfd {
    display: none
  }
}

@media (min-width: 1920px) {
  .gp-featured-content-row .item--33 {
    display: block;
    width: 25%
  }
}

.tile--stackla:nth-child(4) {
  display: none
}

@media (min-width: 1920px) {
  .tile--stackla:nth-child(4) {
    display: inline-block
  }
}

.play-btn {
  background-image: url(../assets/sprite-ui.png);
  background-position: -50px -50px;
  background-size: 302.5px 276.5px;
  width: 45px;
  height: 45px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
}

.gp-featured-content-stackla .tile--stackla:hover .play-btn {
  background-image: url(../assets/sprite-ui.png);
  background-position: 0 -50px;
  background-size: 302.5px 276.5px;
  width: 45px;
  height: 45px
}

@media (min-width: 1920px) {
  .gp-featured-content-stackla .tile--stackla:hover .play-btn {
    background-image: url(../assets/sprite-lfd.png);
    background-position: 0 -61.5px;
    background-size: 251.5px 233.5px;
    width: 56.5px;
    height: 56.5px
  }
}

@media (min-width: 1920px) {
  .gp-featured-content-stackla .play-btn {
    background-image: url(../assets/sprite-lfd.png);
    background-position: -90.5px 0;
    background-size: 251.5px 233.5px;
    width: 56.5px;
    height: 56.5px
  }
}

.gp-featured-content-stackla {
  box-sizing: border-box !important;

  .featured-row-item-image-stackla {
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    width: 40%;
    height: 100%
  }

  .featured-row-item-text-stackla {
    width: 60%;
    left: 40%;
    height: 100%;
    padding-top: 5px;
    padding-bottom: 5px;

    .stackla__text {
      position: absolute;
      text-align: left;
      top: 50%;
      transform: translateY(-50%);
    }

    p {
      margin: 0;
      overflow: hidden;
      max-height: 7.2em;
    }
  }

  .featured-row-item-text-stackla-platform {
    padding-bottom: 20px !important;
  }

  .stackla__info {
    width: 100%;

    * {
      display: inline-block;
    }

    .stackla__platform-icon--twitter {
      background-image: url(../assets/sprite-ui.png);
      background-position: -126.5px -135px;
      background-size: 302.5px 276.5px;
      width: 16px;
      height: 13px;
    }

    .stackla__platform-icon {
      margin-right: 3px;
    }

    .stackla__tile-user {
      display: inline-block;
    }
  }
}

.gp-featured-row-tile:hover .stackla__info:after,
.gp-featured-row-tile:hover .featured-row-item-text:after {
  opacity: 0
}
</style>

<style scoped lang="scss">
/* about us */
#anchor-about {
  background: #232323 none repeat scroll 0 0;
  display: flex;
  justify-content: center;

}

.anchor-about {
  background: #232323 none repeat scroll 0 0;
  margin: 140px 0;

  h2 {
    color: #fff;
    font-size: 45px;
    margin: 0;
    padding-bottom: 10px;
    position: relative;
    text-transform: uppercase;
    font-weight: 100;
    margin: 4px 0;
    text-transform: uppercase;
    letter-spacing: 2px;
  }

  p {
    text-align: left;
    font-size: 15px;
    margin: auto;
    padding: 5px;
    width: 70%;
    color: #707070;
  }
}

#anchor-games {
  .featured-row-item-text {
    text-align: center;

    h2,
    .p-ISBN {
      cursor: pointer;
    }
  }

  .gp-featured-row-item {
    cursor: default;
  }
}
</style>

<style scoped lang="scss">
.noFullDesk .gp-slides-arrows,
.fullDesk .gp-slides-arrows {
  position: absolute;
  z-index: 9;
  top: 50%;
  right: 50px;
  margin-top: -55px;

  .gp-slides-arrow {
    cursor: pointer;
    transition: transform .3s;
  }

  .gp-slides-arrow:hover {
    transform: scale(1.1)
  }

  .gp-slides-arrow-right,
  .gp-slides-arrow-left {
    background-image: url(../assets/sprite-ui.png);
    background-size: 302.5px 276.5px;
    width: 27.5px;
    height: 52px;
  }

  .gp-slides-arrow-right {
    background-position: -132px 0;
  }

  .gp-slides-arrow-left {
    background-position: 0 -100px;
  }
}</style>


// WEBPACK FOOTER //
// src/views/Home.vue